module.exports = __webpack_public_path__ + "img/0.ed48c63a.png";